import React, { useEffect, useState, useRef } from "react";
import "./../styles/components/dgmodal.css";

function DgModal({ modalState, handleModalState, children }) {
  const [isOpen, setIsOpen] = useState(modalState);
  const [flex, setFlex] = useState(false);
  const [opacity, setOpacity] = useState(false);

  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isOpen != modalState) {
      handleModal();
      setIsOpen(modalState);
    }
  }, [modalState]);

  const handleModal = () => {
    if (isOpen) {
      //closing animation
      setOpacity(false);
      setTimeout(function () {
        setFlex(false);
      }, 500);
    } else {
      //opening animation
      setFlex(true);
      setTimeout(function () {
        setOpacity(true);
      }, 100);
    }
  };

  return (
    <div
      className={
        "dgmodal component " + (opacity ? "open " : " ") + (flex ? "flex" : "")
      }
    >
      <div className="modal">
        <div
          className="close"
          onClick={() => {
            handleModalState(false);
          }}
        >
          x
        </div>
        {children}
      </div>
    </div>
  );
}

export default DgModal;
